// Centralized constants for the URL-Zentrale frontend.
// Magic numbers must live here, not scattered across components.

// HTTP
export const API_TIMEOUT_MS = 20_000;
export const HTTP_UNAUTHORIZED = 401;

// React Query
export const QUERY_STALE_TIME_MS = 60_000;

// UI Timings
export const TOAST_DURATION_MS = 2_800;
export const SEARCH_DEBOUNCE_MS = 250;
export const MICROLINK_DEBOUNCE_MS = 600;
export const MICROLINK_STATUS_CLEAR_MS = 2_200;
export const THUMB_REFRESH_SPIN_MS = 700;

// Auth storage keys
export const STORAGE_TOKEN_KEY = "uz_token";
export const STORAGE_EMAIL_KEY = "uz_email";

// Domain options
export const ENTRY_TYPES = [
  "Website",
  "App",
  "Tool",
  "Landing Page",
  "Job-Portal",
  "Backend",
  "Admin Zugänge",
];
export const ENTRY_STATUSES = ["Live", "In Arbeit", "Archiviert"];

// Sort options
export const SORT_OPTIONS = [
  { value: "date_desc", label: "Datum ↓ neueste" },
  { value: "date_asc", label: "Datum ↑ älteste" },
  { value: "name_asc", label: "Name A–Z" },
  { value: "name_desc", label: "Name Z–A" },
];

// Thumbnail strategy
export const THUMB_STRATEGY = {
  THUMBIO: 0,
  MSHOTS: 1,
  FALLBACK: 2,
};

// Hosting classification (derived from entry URL)
export const HOSTING = {
  OWN: "own",
  EMERGENT: "emergent",
  NONE: "none",
};

export const HOSTING_FILTER_OPTIONS = [
  { value: "", label: "Alle Hosting" },
  { value: HOSTING.OWN, label: "🌐 Eigene Domain" },
  { value: HOSTING.EMERGENT, label: "⚡ Emergent" },
  { value: HOSTING.NONE, label: "📝 Ohne URL" },
];
